/* TECHWEAR STORM - CART BUY 3 PROMO & UPSELLS
 *
 * The banner and upsells are rendered by Liquid and refreshed by Prestige's own cart drawer re-render
 * (Section Rendering API) after every cart mutation. This file only adds what Liquid cannot do:
 *   1. announce the new promo message to screen readers (the drawer HTML is replaced, so an in-drawer
 *      aria-live region would be recreated instead of updated)
 *   2. show an inline error when an upsell quick add fails (sold out meanwhile, network error)
 * No polling, no /cart.js request, no dependency.
 */
(() => {
  if (window.__tsCartVolumeDiscount) return;
  window.__tsCartVolumeDiscount = true;

  let live;
  let lastMessage = null;
  let pendingError = null;

  function liveRegion() {
    if (!live) {
      live = document.createElement('div');
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('role', 'status');
      live.className = 'sr-only';
      document.body.appendChild(live);
    }
    return live;
  }

  function currentMessage() {
    return document.querySelector('cart-drawer [data-cvd-message]')?.textContent.trim() || null;
  }

  function onRefreshed() {
    const message = currentMessage();
    if (message && lastMessage !== null && message !== lastMessage) {
      liveRegion().textContent = message;
    }
    lastMessage = message;

    if (pendingError) {
      const container = document.querySelector('cart-drawer [data-cvd-upsells]') || document.querySelector('cart-drawer .cart-volume-discount');
      if (container) {
        const alert = document.createElement('p');
        alert.className = 'cart-upsells__error';
        alert.setAttribute('role', 'alert');
        alert.textContent = pendingError;
        container.prepend(alert);
      }
      pendingError = null;
    }
  }

  document.addEventListener('cart-drawer:refreshed', onRefreshed);

  // Theme dispatches "cart:error" on the form, then "cart:refresh" (drawer re-render): show the error after it
  document.addEventListener('cart:error', (event) => {
    if (!event.target?.closest?.('[data-cvd-form]')) return;
    pendingError = event.detail?.error || 'This item could not be added. Please try again.';
  });

  lastMessage = currentMessage();
})();
